<ion-card mode="ios">
    <ion-card-header color="">
        <ion-card-title color="primary">
            {{ titleKey | translate | uppercase }}
        </ion-card-title>
    </ion-card-header>
    <ion-card-content class="ion-no-padding" *ngIf="report.twoPlusTwoCoaching">
        <ion-grid class="team">
            <ion-row class="header">
                <ion-col size="1"></ion-col>
                <ion-col size="2">
                    {{ 'generic.name' | translate }}
                </ion-col>
                <ion-col *ngFor="let question of questionsConfig">
                    {{ getText(question.globalizationConfig, 'title') }}
                </ion-col>
                <ion-col>
                    {{ 'generic.comments' | translate }}
                </ion-col>
            </ion-row>
            <ion-row class="body">
                <ion-col size="1">
                    <img [src]="getImageUrl(report.user.imageUrl)" default="" class="avatar">
                </ion-col>
                <ion-col size="2">
                    <h3>
                        {{ report.user.name }}<br>
                        {{ 'generic.employee' | translate }}
                    </h3>
                </ion-col>
                <ion-col *ngFor="let question of questionsConfig; let index = index">
                    {{ report.twoPlusTwoCoaching['field' + (index + 1)] }}
                </ion-col>
                <ion-col>--</ion-col>
            </ion-row>
            <ion-row class="body">
                <ion-col size="1">
                    <img [src]="getImageUrl(report.lineManager.imageUrl)" default="" class="avatar">
                </ion-col>
                <ion-col>
                    <h3>
                        {{ report.lineManager.name }}<br>
                        {{ 'generic.manager' | translate }}
                    </h3>
                </ion-col>
                <ion-col *ngFor="let question of questionsConfig; let index = index">
                    {{ report.twoPlusTwoCoaching['field' + (index + 1) + 'Comment'] || '--' }}
                </ion-col>
                <ion-col>
                    {{ report.twoPlusTwoCoaching.managerComment || '--' }}
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>

    <ng-container class="ion-no-padding" *ngIf="!report.twoPlusTwoCoaching">
        <p padding>
            {{ 'generic.noEvaluations' | translate }}
        </p>
    </ng-container>
</ion-card>
